export default __webpack_public_path__ + "static/media/icon-negative-check.8a8aa781.svg";